import styled from '@mui/material/styles/styled';
import MuiTableCell from '@mui/material/TableCell';

const TableCell = styled(MuiTableCell)({
  fontSize: '12px',
  padding: '12px'
});

export default TableCell;